/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalSubmissionQuestionAnswerDataSchema = z.object({
	id: z.string(),
	answer: z.string().nullable(),
	optionId: z.string().nullable(),
	file: z.object({
		id: z.string(),
		candidateId: z.string(),
		name: z.string(),
		fileName: z.string(),
		mimeType: z.string().nullable(),
		size: z.number(),
		url: z.string().nullable(),
		previewUrl: z.string().nullable(),
		createdAt: z.iso.datetime(),
		metadata: z.object({ sourceEmailId: z.string().nullable(), sourceEmailSubject: z.string().nullable() })
			.nullable(),
		scanStatus: z.union([
			z.literal('queued'),
			z.literal('scanning'),
			z.literal('clean'),
			z.literal('infected'),
			z.literal('error'),
			z.literal('skipped'),
		]).nullable(),
		scanSignature: z.string().nullable(),
		attribute: z.literal('cv').nullable(),
	}).nullable(),
})

export type AdditionalSubmissionQuestionAnswerDataSchema = z.infer<typeof additionalSubmissionQuestionAnswerDataSchema>
